import {useState} from "react";
import {Switch} from "antd";

const SwitchSentEmail = ({item, toggleSentEmail}) =>
{
    const [toggleLoading, setToggleLoading] = useState(false);

    function sentEmail(checked)
    {
        setToggleLoading(true);

        toggleSentEmail(item, checked ? 1 : 0).finally(() => {
            setToggleLoading(false);
        });
    }

    return (<div className="d-flex align-items-center justify-content-center mt-1">
        <Switch size="small" checked={item?.isSentEmail === 1} loading={toggleLoading} onChange={sentEmail} />
    </div>);
}

export default SwitchSentEmail;